import React, { useState } from 'react';
import { useTypedTranslation } from '@app/hooks';
import { PasslyTextField } from '@app/components';

interface IReceivedData {
    currentKey: string;
    returnKey: Function;
}

const SecretKeyForMigratorComponent = (props: IReceivedData) => {
    const { translation } = useTypedTranslation();

    const [secretKey, setSecretKey] = useState(props.currentKey);
    const [secretKeyInvalid, setSecretKeyInvalid] = useState(false);
    const secretKeyLength: number = 16;

    const onSecretKeyChange = (e: any) => {
        const { name, value } = e.target;

        setSecretKey(value);

        const secretKeyChosen = e.target.value.trim();

        if (secretKeyChosen === '' || secretKeyChosen.length !== secretKeyLength) {
            setSecretKeyInvalid(true);
            props.returnKey('');
        } else {
            setSecretKeyInvalid(false);
            props.returnKey(secretKeyChosen);
        }
    };

    return (
        <>
            <form method='post'>
                <PasslyTextField
                    name='secretKey'
                    label={'ON_PREM_MIGRATOR_ENTER_SECRET_KEY'}
                    value={secretKey}
                    onChange={onSecretKeyChange}
                    id='secretKey-input'
                    inputProps={{ maxLength: 16 }}
                    error={secretKeyInvalid}
                    helperText={secretKeyInvalid && translation('REQUIRED_FIELD')}
                    autoFocus
                    fullWidth
                />
            </form>
        </>
    );
};

export default SecretKeyForMigratorComponent;
